import { addDays, isSameDay, stripToMonth, stripToWeek, addWeeks } from "../utils/date";
import * as React from "react";
import { Week } from "./Week";

export interface IMonthProps {
    day: Date;
    endDate?: Date;
    excludeDates?: Date[];
    excludeWeekends?: boolean;
    filterDate?: (d: Date) => boolean;
    maxDate?: Date;
    minDate?: Date;
    onDayClick?: (d: Date) => void;
    selected?: Date;
    startDate?: Date;
}

export class Month extends React.Component<IMonthProps, any> {
    public render(): JSX.Element {
        return <tbody>{this.renderWeeks()}</tbody>;
    }
    private handleDayClick(day: Date): void {
        if (this.props.onDayClick) {
            this.props.onDayClick(day);
        }
    }

    private isWeekInMonth(startOfWeek: Date): boolean {
        const day = this.props.day;
        const endOfWeek = addDays(startOfWeek, 6);
        return (
            isSameDay(stripToMonth(startOfWeek), stripToMonth(day)) ||
            isSameDay(stripToMonth(endOfWeek), stripToMonth(day))
        );
    }

    private renderWeeks(): JSX.Element[] {
        const startOfMonth = stripToWeek(stripToMonth(this.props.day));
        return [0, 1, 2, 3, 4, 5]
            .map((offset: number) => addWeeks(startOfMonth, offset))
            .filter((startOfWeek: Date) => this.isWeekInMonth(startOfWeek))
            .map((startOfWeek: Date, offset: number) => (
                <Week
                    key={offset}
                    day={startOfWeek}
                    month={this.props.day.getMonth()}
                    onDayClick={(e: Date) => this.handleDayClick(e)}
                    minDate={this.props.minDate}
                    maxDate={this.props.maxDate}
                    excludeDates={this.props.excludeDates}
                    excludeWeekends={this.props.excludeWeekends}
                    filterDate={this.props.filterDate}
                    selected={this.props.selected}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                />
            ));
    }
}
